import { useQuery } from '@tanstack/react-query';
import { Button, Result } from 'antd';
import type { ReactNode } from 'react';

import { api } from '@/api/client';
import { FullScreenSpin } from '@/components/FullScreenSpin';
import { ru } from '@/i18n/ru';

import { ConfigContext } from './configContext';
import { ProductBranding } from './ProductBranding';

/** Loads the public runtime config (GET /config) before anything else renders. */
export function AppConfigProvider({ children }: { children: ReactNode }) {
  const query = useQuery({
    queryKey: ['config'],
    queryFn: ({ signal }) => api.get('/config', { signal }),
    staleTime: 5 * 60 * 1000,
    retry: 2,
  });

  if (query.isPending) return <FullScreenSpin />;
  if (query.isError) {
    return (
      <Result
        status="warning"
        title={ru.config.unavailable}
        subTitle={ru.config.unavailableHint}
        extra={
          <Button type="primary" onClick={() => void query.refetch()}>
            {ru.config.retry}
          </Button>
        }
      />
    );
  }
  return (
    <ConfigContext.Provider value={query.data}>
      <ProductBranding>{children}</ProductBranding>
    </ConfigContext.Provider>
  );
}
